import axios from '../../admin-axios';
import { detectError } from '../../utils';
import ActionType from '../action-types';

// eslint-disable-next-line import/prefer-default-export
export const getDashboardStats = (stationId) => {
  return async (dispatch) => {
    dispatch({
      type: ActionType.FETCH_DASHBOARD_START
    });

    try {
      // send request to get dashboard stats
      const response = await axios.get(`/dashboard/${stationId}`);

      dispatch({
        type: ActionType.FETCH_DASHBOARD_SUCCESS,
        payload: {
          ...response.data
        } // response data
      });
    } catch (error) {
      const message = detectError(error);
      dispatch({
        type: ActionType.FETCH_DASHBOARD_ERROR,
        payload: message
      });
    }
  };
};
